/** Öffnungs-State der Akte-Mutations-Dialoge (Move/Reclassify/Ordner Neu/Umbenennen/Löschen). */
import { useState } from 'react';
import type { PropertyDocumentKind, PropertyFileResponse } from '@/shared/api';

export function useAkteDialogs() {
  const [moveFile, setMoveFile] = useState<PropertyFileResponse | null>(null);
  const [reclassifyFile, setReclassifyFile] = useState<PropertyFileResponse | null>(null);
  // Vorbelegung des Reclassify-Dialogs beim Cross-Category-Drop: auf die Ziel-Kategorie.
  const [reclassifyKind, setReclassifyKind] = useState<PropertyDocumentKind | null>(null);
  const [deleteFileTarget, setDeleteFileTarget] = useState<PropertyFileResponse | null>(null);
  const [newFolderParent, setNewFolderParent] = useState<string | null>(null);
  const [renameFolder, setRenameFolder] = useState<string | null>(null);
  const [deleteFolder, setDeleteFolder] = useState<string | null>(null);

  return {
    moveFile,
    reclassifyFile,
    reclassifyKind,
    deleteFileTarget,
    newFolderParent,
    renameFolder,
    deleteFolder,
    openMove: setMoveFile,
    /** `suggestedKind` vorbelegt den Dialog (Drag-Ziel-Kategorie); ohne = aktuelles Kind der Datei. */
    openReclassify: (file: PropertyFileResponse, suggestedKind?: PropertyDocumentKind | null) => {
      setReclassifyKind(suggestedKind ?? null);
      setReclassifyFile(file);
    },
    openDeleteFile: setDeleteFileTarget,
    openNewFolder: setNewFolderParent,
    openRenameFolder: setRenameFolder,
    openDeleteFolder: setDeleteFolder,
    closeMove: () => setMoveFile(null),
    closeReclassify: () => {
      setReclassifyFile(null);
      setReclassifyKind(null);
    },
    closeDeleteFile: () => setDeleteFileTarget(null),
    closeNewFolder: () => setNewFolderParent(null),
    closeRenameFolder: () => setRenameFolder(null),
    closeDeleteFolder: () => setDeleteFolder(null),
  };
}
